import { TeamId } from '../types';

import { useTeams } from './useTeams';

const NO_TEAMS: TeamId[] = [];

/** Ids of the teams that currently deny their members access to Portainer. */
export function useTeamsDenyingPortainerAccess() {
  const query = useTeams(false, 0, {
    select: (teams) =>
      teams.filter((team) => team.DenyPortainerAccess).map((team) => team.Id),
  });

  return query.data ?? NO_TEAMS;
}

/**
 * The selected teams whose per-team override differs from their stored value -
 * the only ones needing a write. A team absent from `denyPortainerAccessByTeam`
 * keeps its current state, so an untouched toggle never triggers a write.
 */
export function getTeamsToApplyDenyPortainerAccess(
  selectedTeamIds: TeamId[],
  denyingTeamIds: TeamId[],
  denyPortainerAccessByTeam: Record<TeamId, boolean>
) {
  return selectedTeamIds
    .map((id) => ({
      id,
      denyPortainerAccess:
        denyPortainerAccessByTeam[id] ?? denyingTeamIds.includes(id),
    }))
    .filter(
      ({ id, denyPortainerAccess }) =>
        denyPortainerAccess !== denyingTeamIds.includes(id)
    );
}
